export function debounce<Args extends unknown[]>(
  fn: (...args: Args) => void,
  delayMs: number,
): ((...args: Args) => void) & { flush: () => void; cancel: () => void } {
  let timer: ReturnType<typeof setTimeout> | null = null;
  let pendingArgs: Args | null = null;

  const debounced = (...args: Args) => {
    pendingArgs = args;
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      const toRun = pendingArgs;
      pendingArgs = null;
      if (toRun) fn(...toRun);
    }, delayMs);
  };

  debounced.flush = () => {
    if (timer) clearTimeout(timer);
    timer = null;
    const toRun = pendingArgs;
    pendingArgs = null;
    if (toRun) fn(...toRun);
  };

  debounced.cancel = () => {
    if (timer) clearTimeout(timer);
    timer = null;
    pendingArgs = null;
  };

  return debounced;
}
